@if (exposedFilters().length) {
  <div
    class="view-exposed-filters w-full relative"
    #filtersRef
    [mobiTracking]="{ type: 'view', id: viewId(), name: title() }"
  >
    @for (filter of exposedFilters(); track filter['#id']) {
      <!-- Textfield based filters -->
      @if (filter['#type'] === 'textfield') {
        <div
          class="w-full searchfield mobi-ui-ink-default mobi-ui-padding-y-md mobi-ui-width-full"
        >
          <mobi-ui-input-major
            [icon]="filters()[filter['#name']] ? 'the_x' : 'search'"
            [aria-label]="filter.expose?.label || 'searchfield'"
            [value]="filters()[filter['#name']] || ''"
            (iconClick)="updateFilters(filter['#name'], '', true)"
            (valueChange)="onTextFilterChange(filter['#name'], $event)"
            [placeholder]="
              filter['#attributes']?.placeholder || 'search_term'
                | texts: { context: 'frontend', default: 'Suchbegriff' }
            "
            [autofocus]="autofocus()"
          />
        </div>
      }
    }
    <div class="flex smMax:flex-col justify-between w-full -mx-[8px]">
      @for (filter of exposedFilters(); track filter['#id']) {
        @if (!hideFilters().includes(filter['#name'])) {
          @switch (filter['#type']) {
            <!-- empty container for hidden fields -->
            @case ('hidden') {}
            <!-- Datepicker and year select -->
            @case ('date') {
              @if (filter['#name'] === 'year') {
                <mobi-select
                  [name]="filter['#name']"
                  [title]="filter['#title']"
                  [options]="yearArray"
                  [emptyOption]="
                    'all_years' | texts: { context: 'frontend', default: 'Alle Jahre' }
                  "
                  [selected]="selectedOption(filter['#name'])"
                  icon="calendar"
                  (onChange)="updateFilters(filter['#name'], $event, true)"
                />
              }
              @if (filter['#name'] !== 'year') {
                <mobi-ui-datepicker-major
                  class="block w-auto mobi-ui-padding-y-md"
                  [value]="filters()[filter['#name']] || ''"
                  aria-label="Datepicker example"
                  (valueChange)="updateFilters(filter['#name'], $event, true)"
                />
              }
            }
            <!-- Select based filters -->
            @case ('select') {
              <!-- single select -->
              @if (!filter['#multiple'] && filter['#name'] === 'location_id') {
                @if (filter['#all_options'] && filter['#all_options'].length) {
                  <mobi-select
                    class="block px-[8px]"
                    [name]="filter['#name']"
                    [options]="filter['#all_options']"
                    [emptyOption]="
                      'all_locations'
                        | texts: { context: 'frontend', default: 'Alle Agenturen' }
                    "
                    [selected]="selectedOption(filter['#name'])"
                    icon="location_pin"
                    (onChange)="updateFilters(filter['#name'], $event, true)"
                  />
                } @else {
                  <mobi-select
                    class="block px-[8px]"
                    [name]="filter['#name']"
                    [options]="filter['#optionsArray']"
                    [emptyOption]="
                      'all_locations'
                        | texts: { context: 'frontend', default: 'Alle Agenturen' }
                    "
                    [selected]="selectedOption(filter['#name'])"
                    icon="location_pin"
                    (onChange)="updateFilters(filter['#name'], $event, true)"
                  />
                }
              }
              @if (filter['#name'] === 'langcode') {
                <mobi-select
                  class="block px-[8px]"
                  [name]="filter['#name']"
                  [options]="filter['#optionsArray']"
                  [selected]="selectedOption(filter['#name'])"
                  [hideEmptyOption]="true"
                  icon="message"
                  (onChange)="updateFilters(filter['#name'], $event, true)"
                />
              }

              @if (
                filter['#multiple'] &&
                filter['#processedOptions']?.length &&
                filter['#processedOptions'][0].children?.length > 1
              ) {
                <mobi-tags-filter
                  class="block px-[8px]"
                  [filter]="filter"
                  [activeFilters]="filters()"
                  [scrollable]="scrollable()"
                  type="select"
                  (selectionChange)="updateSelection($event.name, $event.key)"
                />
              }
            }
            <!-- Checkboxes -->
            @case ('checkboxes') {
              <mobi-tags-filter
                class="block px-[8px]"
                [isGrouped]="isGrouped(filter['#name'])"
                [filter]="filter"
                [activeFilters]="filters()"
                [centerFilters]="centerFilters()"
                [scrollable]="scrollable()"
                type="checkboxes"
                (selectionChange)="updateSelection($event.name, $event.key)"
              />
            }
            <!-- Radios -->
            @case ('radios') {
              <mobi-tags-filter
                class="block px-[8px]"
                [filter]="filter"
                [activeFilters]="filters()"
                [centerFilters]="centerFilters()"
                [scrollable]="scrollable()"
                type="radios"
                (filterChange)="
                  updateFilters($event.name, $event.value, $event.immediate)
                "
              />
            }

            <!-- Numbers -->
            @case ('number') {
              @if (filter['#name'] === 'rating') {
                <mobi-select
                  class="block px-[8px]"
                  [name]="filter['#name']"
                  [options]="filter['#optionsArray']"
                  [emptyOption]="
                    'all_ratings'
                      | texts: { context: 'frontend', default: 'Alle Bewertungen' }
                  "
                  [selected]="selectedOption(filter['#name'])"
                  icon="star"
                  (onChange)="updateFilters(filter['#name'], $event, true)"
                />
              }
            }
          }
        }
      }
    </div>
  </div>
}
